const getters = {
    token: state => state.auth.token,
    isAuthenticated: state => !!state.auth.token,
    name: state => state.auth.name,
    avatar: state => state.auth.avatar,
    pers: state => state.auth.pers,
}
  
  export default getters